/**
 * Maps alternatives-sheet `scope` to GTM `page_section` (`gpo` → fixed; `all` → `{origin}_product_alternatives`).
 * See docs/GLOBAL_CUSTOM_TRACKING.md (Alternatives overlay page_section override).
 */
export function resolveAlternativesTrackingSection(
  scope: 'gpo' | 'all',
  originPageSection: string,
): string {
  if (scope === 'gpo') return 'cart_gpo_recommendation'
  return `${originPageSection}_product_alternatives`
}

/**
 * Global page_section override while ProductAlternativesBottomSheet is open (needed for teleported scale-price sheet).
 * `null` = no overlay open → trackers fall back to the route-derived section.
 */
export function useAlternativesTrackingSection() {
  const section = useState<string | null>('alternatives-overlay:tracking-section', () => null)

  function set(value: string) {
    section.value = value
  }

  function clear() {
    section.value = null
  }

  return {
    section,
    set,
    clear,
  }
}
